import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=17a0d9de&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a0d9de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17a0d9de')) {
      api.createRecord('17a0d9de', component.options)
    } else {
      api.reload('17a0d9de', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=17a0d9de&scoped=true&", function () {
      api.rerender('17a0d9de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HhNIENO9CX6e/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports